import React from 'react'
import Servicedetail from '../components/servicedetail/Servicedetail'
import Pagetitle from '../components/pagetitle/Pagetitle'
import productimg from './../Images/ProductDesign-2710a0f324f1b37799e4bdacba958305.png'
export default function Productanddesign() {
  const servicetechnologies = ['Adobe Photoshop',
'Adobe illustrator',
'Adobe XD']
  return (
    <div>
      <Pagetitle pagename="Product & Design" parentpage="Home" />
      <Servicedetail serviceimg={productimg} technologies={servicetechnologies} servicesabout="Product designing is exactly what end-user see. Our creative graphics designers will make a suitable and fresh design ideas for your product.​​" />
    </div>
  )
}
